import { DataPackValue } from '../../app/models/dataPackValue.model';

/**
 * @author Edivaldo Junior
 * @version $Id: voiceConsumptionBatchProcessing.model.ts 87745 2018-04-23 22:02:59Z edivaldo.m.junior $
 */
export class VoiceConsumptionBatchProcessing {

  public static NONE: string = "NONE";
  public static PENDING: string = "PENDING";
  public static PROCESSED: string = "PROCESSED";
  public static FINISHED: string = "FINISHED";
  public static ZERO: number = 0;

  public limitProcessingStatus: string;
  public overBalanceProcessingStatus: string;
  public overBalanceNextCycleProcessingStatus: string;
  public linesWithSuccessLimit: string;
  public linesWithErrorLimit: string;
  public linesWithSuccessOverBalance: string;
  public linesWithErrorOverBalance: string;
  public linesWithSuccessOverBalanceNextCycle: string;
  public linesWithErrorOverBalanceNextCycle: string;
  public processStatus: string;
  
  public constructor() {
  }
}


// WEBPACK FOOTER //
// ./src/app/models/voiceConsumptionBatchProcessing.model.ts